<template>
  <div class="">
  <!-- <FinancialData/> -->
  

    <div class="row">
      <div class="col-md-12">
      

<!-- <StudentAccount/> -->



<!-- 
                <div class="text-center" v-if="isLoadingAccount ">
                 <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div>
            <b-row v-if="AccountDetails.length > 0">
              <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                <div class="profileData">
              Creation Date
                </div>
                </b-col>
                 <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                   <div class="profileData2">
                <span> {{AccountDetails[0].CreationDate | moment("ll") }} </span>
                   </div>
              </b-col>

                 <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                <div class="profileData">
             No. Of Approved Transaction
                 </div>
                </b-col>
                 <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                   <div class="profileData2">
                <span class=""> {{AccountDetails[0].NoOfApproved}}</span>
                   </div>
              </b-col>
           

              <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                <div class="profileData">
               No. Of Pending Transaction
                </div>
                 </b-col>
                 <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                   <div class="profileData2">
                <span > {{AccountDetails[0].NoOfPending}}</span>
                   </div>
              </b-col>

               <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                <div class="profileData">
               No. Of Void Transaction
                 </div>
                 </b-col>
                 <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                   <div class="profileData2">
                <span> {{AccountDetails[0].NoOfVoid}}</span>
              </div>
              </b-col>


              <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                <div class="profileData">
                Last Deposit Date 
                </div>
                 </b-col>
                 <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                   <div class="profileData2">
                <span>{{AccountDetails[0].LastDebositDate  | moment("ll") }}</span>
                   </div>
              </b-col>

              <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                <div class="profileData">
             Pending Credit
                </div>
                 </b-col>
                 <b-col cols="3" class="mb-2 col-sm-12 col-md-3">
                   <div class="profileData2">
                <span> {{AccountDetails[0].PendingCredit}}</span>
                   </div>
              </b-col>

            </b-row> -->
         
      </div>
    </div>
  
    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Payments</div>
          <div class="panal-body">

 <div class="bg-filter">
   <div class="row ">     
    <div class="col-md-5">
<label >Payment Method</label>
<!-- :options="options" -->
   <b-form-select v-model="search" v-b-tooltip.hover title="Choose payment method" >
     <option value="null">Choose payment </option>
     <option v-for="payment in paymentMethods" :key="payment.serial" :value="payment.AmountTypeName">
          {{payment.AmountTypeName}}
     </option>
   </b-form-select>
   

    </div>
    <div class="col-md-5">
<label >Select Currency</label>
<!-- :options="options" -->
   <b-form-select v-model="Currency" v-b-tooltip.hover title="Choose Currency" >
     <option value="null">Choose payment </option>
     <option v-for="payment in CurrencyList" :key="payment.serial" :value="payment.serial">
          {{payment.CurrencyNameEN}}
     </option>
   </b-form-select>
   

    </div>

    <!-- <div class="col-md-5">

    <label >Payment Date</label>
  <b-form-datepicker id="End" class="mb-2"></b-form-datepicker>
  

    </div> -->
<div class="col-md-2 align-middle mt-4">
   <span class="align-middle">
     <b-button variant="success mt-2" @click="Search">Search</b-button>
   </span>
    </div>
    </div>
    </div>
<!-- <input type="text" v-model="search" placeholder="search Method" /> -->


            <div class="table-responsive">
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Payment Date</th>
                    <th scope="col">Value</th>
                    <th scope="col">Payment Status</th>
                    <th scope="col">Payment Method</th>

                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                   <tr v-if="filteredMethod.length == 0"><td colspan="7"> No Data </td></tr>
                  <tr v-else v-for="item in filteredMethod" v-bind:Key="item.PaymentDetailsID">
                    <td>{{item.PaymentDate}}</td>

                    <td>{{item.Amount | toCurrency}}</td>

                    <td>{{item.PaymentStatus}}</td>
                    <td>{{item.PaymentMethod}}</td>
                    <td>
                      <!-- v-b-modal.Bank 
                      
                       @click="openmodel(Bank.id)" id="show-modal"   v-b-modal.Bank 
                      
                      -->
                      <b-button variant="primary" @click="getdit(item, item.PaymentMethod)"
                       >View Details</b-button
                      >

           

                    </td>
                  </tr>
             <b-modal id="Bank" title="Bank Details"  name="Bank" ok-only>
                        <table class="table mt-3 table-bordered">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col">Recipt Number</th>
                              <th scope="col">Bank Name</th>
                              <th scope="col">Bank Branch</th>
                              <th scope="col">Deposit Date</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-if="empty"><td colspan="4"> No Data </td></tr>
                            <tr v-else v-for="(item,index) in actionsAdvanced" v-bind:Key="index">
                              <td>{{item.ReceiptNumber}}</td>
                              <template v-if="currentItem.IsSystemTypeMethod != true">
                              <td>{{item.Bank}}</td>
                              <td>{{item.BankBranch}}</td>

                              <td>{{item.Bank_DepositDate}}</td>
                            </template>
                            </tr>
                          </tbody>
                        </table>
                      </b-modal>

<b-modal id="Cash" title="Cash Details"  name="Cash" ok-only >
                        <table class="table mt-3 table-bordered">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col">Recipt Number</th>
                              <th scope="col">save box</th>
                            </tr>
                          </thead>

                          <tbody>
                              <tr v-if="empty"><td colspan="2"> No Data </td></tr>
                            <tr v-else v-for="item in actionsAdvanced" v-bind:Key="item.StudentID">
                              <td>{{item.ReceiptNumber}}</td>
                              <template v-if="currentItem.IsSystemTypeMethod != true">
                              <td>{{item.SafeBoxNameEN}}</td>
                              </template>
                            </tr>
                          </tbody>
                        </table>
                      </b-modal>


<b-modal id="Cheque"  title="Cheque Details"  ok-only>
                        <table class="table mt-3 table-bordered">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col">Recipt Number</th>
                              <th scope="col">Bank Name</th>
                              <th scope="col">Bank Branch</th>
                              <th scope="col">DueDate</th>
                              <th scope="col">Check Number</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-if="empty"><td colspan="2"> No Data </td></tr>
                            <tr v-else v-for="item in actionsAdvanced" v-bind:Key="item.StudentID">
                              <td>{{item.ReceiptNumber}}</td>
                              <template v-if="currentItem.IsSystemTypeMethod != true">
                              <td>{{item.Cheque_Bank}}</td>
                              <td>{{item.Cheque_BankBranch}}</td>

                              <td>{{item.DueDate}}</td>
                              <td>{{item.ChequeNo}}</td>
                              </template>
                            </tr>
                          </tbody>
                        </table>
                      </b-modal>


  <b-modal id="Transfer" title="Transfer Details" ok-only>
                        <table class="table mt-3 table-bordered">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col">Recipt Number</th>
                              <th scope="col">Swift Code</th>
                              <th scope="col">Transfer date</th>
                           
                            </tr>
                          </thead>

                          <tbody>
                             <tr v-if="empty"><td colspan="2"> No Data </td></tr>
                            <tr v-else v-for="item in actionsAdvanced" v-bind:Key="item.StudentID">
                              <td>{{item.ReceiptNumber}}</td>
                              <template v-if="currentItem.IsSystemTypeMethod != true">
                              <td>{{item.SwifCode}}</td>
                              <td>{{item.TransferDate}}</td>
</template>
                          
                            </tr>
                          </tbody>
                        </table>
                      </b-modal>                    
                </tbody>
              </table>
              <p>
<button @click="prevPage" class="btn btn-primary" :disabled="currentPage == 1">{{currentPage == 1 ? 'First' : 'previous'}}</button> 
    {{currentPage }} of {{(StudentTransactions.length / pageSize).toFixed()}}
<button class="btn btn-primary" @click="nextPage" :disabled="currentPage == (StudentTransactions.length / pageSize).toFixed()">{{currentPage == (StudentTransactions.length / pageSize).toFixed() ? 'Last' : 'next'}}</button>
</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import FinancialData from "../../components/Financial/FinancialData.vue";
// import StudentAccount from "../../components/Financial/StudentAccount.vue";
import studentData from '../../services/student/studentDataServices';
export default {
     components: {
      // FinancialData,StudentAccount
  
  },
  
  name: "CashReceipt",
  data() {
    return {
      selected: null,
      show: true,
      AccountDetails:'',
      StudentTransactions:[],
      actionsAdvanced:'',
      search:null,
      model:'',
      name:'',
      empty: false,
      isHidden: false,
      paymentMethods: [],
      options: [
          { value: null, text: 'Select Method',},
          { value: 'Cash', text: 'Cash' },
          { value: 'Bank', text: 'Bank' },
          { value: 'Cheque', text: 'Cheque' },
          { value: 'Transfer', text: 'Transfer' },

     ],
     isLoadingAccount : true,
     pageSize:5,
  currentPage:1,
  Currency:1,
  CurrencyList:[],
  currentItem:[]
    };
  },
  computed:{
           currenUser(){
            return  this.$store.state.auth.user
          },
          filteredMethod: function(){
            
          return this.StudentTransactions.filter((item) =>{
            if (this.search == 'null' || this.search == null) {
              return item
            }
            return item.PaymentMethod == this.search;
          }).filter((row, index) => {
		let start = (this.currentPage-1)*this.pageSize;
		let end = this.currentPage*this.pageSize;
		if(index >= start && index < end) return true;
	});
},
         

       },
  mounted(){
        
      //this.currenUser.StudentID // 4
            studentData.GetStudentAccountDetails(this.currenUser.StudentID , this.Currency).then(Response =>{
              // this.isLoading = false ;
               this.AccountDetails = Response.data
               this.isLoadingAccount =false
                // eslint-disable-next-line no-console
                 // console.log('AccountDetails => ',Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                   this.isLoadingAccount =false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }),

              //this.currenUser.StudentID // 4
            studentData.GetStudentTransactions(this.currenUser.StudentID,0,'1/1/0001').then(Response =>{
              // this.isLoading = false ;

               this.StudentTransactions = Response.data
                // eslint-disable-next-line no-console
                //  console.log('StudentTransactions => ',Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                //  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })

          //        //this.currenUser.StudentID
          //   studentData.GetStudentTransactionsAdvanced(4,677,'false' ,'true' ,'false' ,'false').then(Response =>{
          //     // this.isLoading = false ;
          //      this.actionsAdvanced = Response.data
          //       // eslint-disable-next-line no-console
          //         console.log(Response.data)
          //  }, error => {
              
          //         // eslint-disable-next-line no-console
          //         console.log(error.response.status)
                 
          //     this.message =
          //       (error.response && error.response.data && error.response.data.Message) ||
          //       error.message ||
          //       error.toString();
                
          //       if(error.response.status == 404) this.message =''
             
          //   })


       studentData.GetPaymentMethods().then(Response =>{
              // this.isLoading = false ;
               this.paymentMethods = Response.data
                // eslint-disable-next-line no-console
               //   console.log('Payment Methods => ',Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                //  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })      
       studentData.GetCurrencies().then(Response =>{
              // this.isLoading = false ;
               this.CurrencyList = Response.data
                // eslint-disable-next-line no-console
               //   console.log('Payment Methods => ',Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                //  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })      
    },


      methods: {

  getdit(item, paymentMethod){
      /* eslint-disable no-console */
     // console.log("works")
     
          this.currentItem  = item;
          
          //this.currenUser.StudentID,item.CourseID,item.RoleReviewID
          //studentData.GetStudentTransactionsAdvanced(4,677,'false' ,'true' ,'false' ,'false').then(
          studentData.GetStudentTransactionsAdvanced(this.currenUser.StudentID,item.PaymentDetailsID,item.IsCash ,item.IsBank ,item.IsTransfer ,item.IsCheque ,item.IsSystemTypeMethod).then(
             (Response) => {
          this.isLoading = false;
          this.empty = false
          this.actionsAdvanced = Response.data;
           this.$bvModal.show(paymentMethod);
          // eslint-disable-next-line no-console
         // console.log('Advanced => ',this.PaymentMethod);
        },
        (error) => {
          // eslint-disable-next-line no-console
        //  console.log(error.response.status);

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      
          )
    },




    // set active modal and set index wich content is activeted
    modalOpen() {
  
      // if(("#").length == Bank){
        
      //    this.showModal = true; 

      // }
      // else if(("#") ==Cash){
      //    this.showModal = true; 

      // }  
  // return this.active = i;
          //this.showModal = true; 
//this.$refs.showModal.show()
          return this.StudentTransactions.filter((item) =>{
          return item.PaymentMethod.match(this.id);
         
});




      },

nextPage:function() {
  if((this.currentPage*this.pageSize) < this.StudentTransactions.length) this.currentPage++;
},
prevPage:function() {
  if(this.currentPage > 1) this.currentPage--;
},
  
  Search(){
    studentData.GetStudentAccountDetails(this.currenUser.StudentID , this.Currency).then(Response =>{
              // this.isLoading = false ;
               this.AccountDetails = Response.data
               this.isLoadingAccount =false
                // eslint-disable-next-line no-console
                 // console.log('AccountDetails => ',Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                   this.isLoadingAccount =false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })

  }
}

      
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  border: 1px solid #a6a6a6;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}

.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}

.divider {
    height: 0;
    margin: 0.5rem 0;
    overflow: hidden;
    border-top: 1px solid #e9ecef;
}

.app-All {
  width: 75%;
  float: left;
}

.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;

  float: left;
}

.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-dark th {
  color: #fff;
  background-color: #dee2e6 !important;
  border-color: #989899 !important;
  font-size: 13px !important;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
  font-size: 13px !important;
}

.bg-filter {
  background: #cacaca;
  padding: 10px;
  width: 100%;
}
.show {
  display: none;
}
.badge {
  padding: 0.65em 0.6em;
}

.profileData, .profileData2 {
    border: 1px dotted #646464;
    padding: 3px 10px;
    font-weight: 700;
}
.profileData {
    color: #285475;
}
.profileData2 {
    color: #ff8600;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>
